import request from '@/utils/request';

// 获取菜单
export function getMenuData() {
  return request({
    url: '/subject/reception/menu',
    method: 'get'
  });
}

// 获取首页数据
export function getHomeData() {
  return request({
    url: '/subject/reception/home',
    method: 'get',
  });
}

// 获取文章详情
export function getArticleDetail(id) {
  return request({
    url: `/subject/reception/article/${id}`,
    method: 'get',
  });
}

// 文章搜索
export function getArticleQuery(params) {
  return request({
    url: `/subject/reception/article/query`,
    method: 'get',
    params,
  });
}

// 获取文章列表
export function getArticleList(activeId, params) {
  return request({
    url: `/subject/reception/menu/item/${activeId}`,
    method: 'get',
    params,
  });
}

// 需求发布
export function saveCompanyDemand(data) {
  return request({
    url: `/subject/companyDemand`,
    method: 'post',
    data,
  });
}

// 需求批量发布
export function saveCompanyDemandList(data) {
  return request({
    url: `/subject/companyDemand/list`,
    method: 'post',
    data,
  });
}

// 科技成果发布（companyDemand -> researchDemand）
export function saveResearchDemand(data) {
  return request({
    url: `/subject/researchDemand`,
    method: 'post',
    data,
  });
}

// 技术成果批量发布
export function saveResearchDemandList(data) {
  return request({
    url: `/subject/researchDemand/list`,
    method: 'post',
    data,
  });
}

// 科技成果导入
export function importResearchDemandExcel(data) {
  return request({
    url: '/subject/researchDemand/readExcel',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
}

// 分页查询企业需求
export function getCompanyDemandList(params) {
  return request({
    url: `/subject/reception/companyDemand/query`,
    method: 'get',
    params,
  });
}

// 科技成果分页查询
export function getResearchDemandList(params) {
  return request({
    url: `/subject/reception/researchDemand/query`,
    method: 'get',
    params,
  });
}

// 查询企业需求详情
export function getCompanyDemandDetail(id) {
  return request({
    url: `/subject/reception/companyDemand/info/${id}`,
    method: 'get',
  });
}

// 科技成果详情查询
export function getResearchDemandDetail(id) {
  return request({
    url: `/subject/reception/researchDemand/info/${id}`,
    method: 'get',
  });
}

// 企业需求顶部滚动，非分页
export function getCompanyDemandTop() {
  return request({
    url: `/subject/reception/companyDemand/top`,
    method: 'get',
  });
}

// 科技成果顶部滚动，非分页
export function getResearchDemandTop() {
  return request({
    url: `/subject/reception/researchDemand/top`,
    method: 'get',
  });
}

// 分页查询高校
export function getSchoolList(params) {
  return request({
    url: `/subject/reception/school/query`,
    method: 'get',
    params,
  });
}

// 查询高校信息详情
export function getSchoolDetail(id) {
  return request({
    url: `/subject/reception/school/info/${id}`,
    method: 'get'
  });
}

export function getCompanyBadge() {
  return request({
    url: `/subject/reception/companyDemand/badge`,
    method: 'get',
  });
}

// 科技成果徽标统计
export function getResearchBadge() {
  return request({
    url: `/subject/reception/researchDemand/badge`,
    method: 'get',
  });
}

// 企业需求导入（excel）
export function importCompanyDemandExcel(data) {
  return request({
    url: '/subject/companyDemand/readExcel',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
}